import { useState, useEffect, useMemo, useRef } from 'react';
import { Tree, TreeSelectionEvent, TreeCheckboxSelectionKeys, TreeMultipleSelectionKeys } from 'primereact/tree';
import TreeNode from 'primereact/treenode';
import { Button } from 'primereact/button';
import { Toolbar } from 'primereact/toolbar';
import referenceService from './refrence-service';
import { Fieldset } from 'primereact/fieldset';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { useLocation, useNavigate } from 'react-router-dom';
import { Toast } from 'primereact/toast';
import { InputSwitch } from 'primereact/inputswitch';
import BreadcrumbComponent from '../../../../components/Breadcrumb';

interface DropdownItem {
    referenceName: string;
    referenceCode: string;
    fullDesc: string;
    objectId: string;
}

const ReferenceEdit: React.FC = () => {
    const [menuSetDropdown, setMenuSetDropdown] = useState<DropdownItem[]>([]);
    const [clientState, setClientState] = useState<any>(null);
    const [selectedNodeJson, setSelectedNodeJson] = useState<any>(null);
    const [moduleDropdown, setModuleDropdown] = useState<DropdownItem[]>([]);
    const navigate = useNavigate();
    const toast = useRef<Toast>(null);
    const location = useLocation();
    const referenceItem = location.state?.item;
    const [reference, setReference] = useState<any>(null);

    const menuSetDropdownOptions = useMemo(() => menuSetDropdown, [menuSetDropdown]);
    const moduleDropdownOptions = useMemo(() => moduleDropdown, [moduleDropdown]);

    const defaultData = {
        recordStatus: true,
        moduleId: null,
        fullDesc: null,
        shortDesc: null,
        orderSeq: null,
        referenceGroup: null,
        isEdit: false
    }

    useEffect(() => {
        const fetchClientState = async () => {
            try {
                referenceService.getClientState().then((data) => {
                    setClientState(data);
                });

                referenceService.getModuleDropdown().then((data) => {
                    setModuleDropdown(data);
                });



                if (referenceItem !== undefined) {
                    referenceItem.recordStatus = referenceItem.recordStatus == '1' ? true : false;
                    referenceItem.isEdit = true
                    setReference(referenceItem);
                } else {
                    setReference(defaultData);
                };


            } catch (error) {
                console.error('Error fetching client state:', error);
            }
        };

        fetchClientState();
    }, []);

    const handleInputChange = (e: any) => {
        const { id, value } = e.target;
        setReference({
            ...reference,
            [id]: value
        });
    };

    const handleDropdownChange = (e: any) => {
        const { id, value } = e.target;
        setReference({
            ...reference,
            [id]: value
        });
    };

    const handleReferenceGroupInputChange = (e: any) => {
        const { id, value } = e.target;
        setReference({
            ...reference,
            [id]: value.toUpperCase(),
        });
    };

    const footerTemplate = () => {
        function submit(): void {
            const currentDate = new Date().toLocaleString("en-US", { timeZone: clientState.timeZone });

            reference.modifiedDate = new Date(currentDate);
            reference.modifiedBy = clientState.userId;
            reference.recordStatus = reference.recordStatus == true ? '1' : '0';
            reference.fullDescEnglish = reference.fullDesc;
            reference.adminOnly = 'Y';

            if (reference.isEdit === false) {

                reference.insertDate = new Date(currentDate);
                reference.insertBy = clientState.userId;

                referenceService.create(reference).then(() => {
                    clientState.success.detail = 'Already Save Record';
                    toast.current?.show(clientState.success);
                    navigate("/admin/reference");

                }).catch((error) => {
                    const errorMessage = error.response?.data?.message || 'Failed to create record.';
                    clientState.error.detail = errorMessage;
                    toast.current?.show(clientState.error);
                });
            } else {
                referenceService.update(reference).then(() => {
                    clientState.success.detail = 'Already Save Record';
                    toast.current?.show(clientState.success);
                    navigate("/admin/reference");

                }).catch((error) => {
                    const errorMessage = error.response?.data?.message || 'Failed to create record.';
                    clientState.error.detail = errorMessage;
                    toast.current?.show(clientState.error);
                });
            }

        }

        function handleBack(): void {
            navigate(`/admin/reference`);
        }

        return (
            <>
                <Toast ref={toast} />
                <Button label="Save" icon="pi pi-check" style={{ marginRight: '.5em' }} className="p-button-success" onClick={submit} />
                <Button label="Back" icon="pi pi-trash" style={{ marginRight: '.5em' }} onClick={() => handleBack()} />

            </>
        );
    };

    return (
        <div className="grid">
            <div className='col-12'>
                <div className='card-title'>
                    <h5>Reference Form</h5>
                    <BreadcrumbComponent />
                </div>
                <div className='form-title'>
                    <Fieldset legend="Module Information">
                        <div className="p-fluid form-grid grid">
                            <div className="field col-12 md:col-6">
                                <label htmlFor="departmentCode">Module ID</label>
                                <Dropdown
                                    id="moduleId"
                                    value={reference?.moduleId || ''}
                                    onChange={handleDropdownChange}
                                    options={moduleDropdownOptions}
                                    optionLabel="fullDesc"
                                    placeholder="Select One"
                                    optionValue="moduleId"
                                >
                                </Dropdown>
                            </div>
                            <div className="field col-12 md:col-6">
                                <label>reference Group</label>
                                <InputText
                                    id="referenceGroup"
                                    value={reference?.referenceGroup || ''}
                                    onChange={handleReferenceGroupInputChange}
                                    placeholder="Eg: REFERENCE_GROUP"
                                />
                            </div>
                            <div className="field col-12 md:col-6">
                                <label>Full Description</label>
                                <InputText
                                    id="fullDesc"
                                    value={reference?.fullDesc || ''}
                                    onChange={handleInputChange}
                                />
                            </div>
                            <div className="field col-12 md:col-6">
                                <label>Short Description</label>
                                <InputText
                                    id="shortDesc"
                                    value={reference?.shortDesc || ''}
                                    onChange={handleInputChange}
                                />
                            </div>
                            <div className="field col-12 md:col-6">
                                <h6>Status</h6>
                                <InputSwitch
                                    checked={reference?.recordStatus || ''}
                                    onChange={(e) => setReference({ ...reference, recordStatus: e.value })}
                                />
                            </div>
                        </div>
                    </Fieldset>
                    <div>
                        <br />
                    </div>
                    <Toolbar end={footerTemplate}></Toolbar>
                </div>
            </div>
        </div>

    );
};

export default ReferenceEdit;
